import $i18n from '@alife/panda-i18n';
import React, { useCallback, useEffect, useState } from 'react';
import { CnDialog, CnAsyncSelect, Form, Field, CnMessage } from '@alife/cn-ui';
import { saveVasSelfPayerInfo } from '../../api';
const FormItem = Form.Item;
export default function AccountInfo(props) {
    const { accountInfoMode, setAccountInfoMode, asnCode, cardMapData, handleSearch, payerList, } = props;
    const field = Field.useField();
    const [loading, setLoading] = useState(false);
    const [payerFilterList, setPayerFilterList] = useState(payerList);
    const savePayerRequest = (params) => {
        saveVasSelfPayerInfo({
            asnCode,
            ...params,
        })
            .then(() => {
            setLoading(false);
            CnMessage.success($i18n.get({ id: '', dm: '更换结算信息成功' }));
            setAccountInfoMode(false);
            handleSearch();
        })
            .catch((error) => {
            setLoading(false);
            CnMessage.error(error?.message);
            setAccountInfoMode(false);
        });
    };
    // 保存
    const handleSave = useCallback(() => {
        field.validate((error, values) => {
            if (error) {
                return;
            }
            setLoading(true);
            const { vasSelfPayerName, vasSelfAccountType } = values;
            const { label = '' } = (payerList &&
                payerList.find((item) => {
                    return item.value === vasSelfPayerName;
                })) ||
                {};
            const vasSelfPayer = (label && label?.split(' ')) || [];
            const payerInfo = vasSelfPayer && {
                vasSelfPayerId: vasSelfPayer?.[1] || '',
                vasSelfPayerName: vasSelfPayer?.[0] || '',
                vasSelfAccountType,
                changeAccountTypeFlag: true,
            };
            savePayerRequest(payerInfo);
        });
    }, [accountInfoMode, asnCode, field, setAccountInfoMode, handleSearch]);
    // 关闭
    const onClose = useCallback(() => {
        setAccountInfoMode(false);
    }, []);
    // 初始化
    useEffect(() => {
        if (cardMapData.length === 1) {
            if (disabledTypeCodes.includes(cardMapData[0]?.typeCode)) {
                field.setValue('vasSelfAccountType', 1);
                const filterData = payerList.filter((item) => item?.vasSelfAccountType == 1);
                setPayerFilterList(filterData);
            }
            else {
                field.setValue('vasSelfAccountType', null);
            }
        }
    }, [cardMapData, setAccountInfoMode, accountInfoMode]);
    // 如果月结/扫码实时/划扣实时 都是一类，选择更改结算方式就是出来现结，
    // 如果是现结时，更换结算方式就是这三个选择1个就行。月结/扫码实时/划扣实时这三个（非现结） 不会同时存在一个ASN里
    const disabledTypeCodes = ['2', '4', '5'];
    const fullDataSource = [
        { label: '现结', value: 1 },
        { label: '月结', value: 2 },
        { label: '商家支付宝代扣（实时）', value: 4 },
        { label: '现场扫码付（实时）', value: 5 },
    ];
    const changeFilterList = (value) => {
        const filterData = payerList.filter((item) => item?.vasSelfAccountType == value);
        setPayerFilterList(filterData);
    };
    const filteredDataSource = cardMapData[0]?.typeCode === '1'
        ? fullDataSource.filter((item) => item.value !== 1)
        : fullDataSource;
    return (React.createElement(CnDialog, { size: 'medium', className: 'asn-add-service', title: $i18n.get({ id: '', dm: '更换结算信息' }), visible: accountInfoMode, onClose: onClose, onCancel: onClose, onOk: handleSave, okProps: { loading, disabled: loading } },
        React.createElement(React.Fragment, null,
            React.createElement(Form, { field: field },
                React.createElement(FormItem, { label: '\u7ED3\u7B97\u65B9\u5F0F', name: 'vasSelfAccountType', required: true, requiredMessage: '请选择结算方式' },
                    React.createElement(CnAsyncSelect, { showSearch: true, hasClear: true, dataSource: filteredDataSource, disabled: disabledTypeCodes.includes(cardMapData[0]?.typeCode), onChange: (value) => {
                            changeFilterList(value);
                        }, style: { width: '30%' } })),
                React.createElement(FormItem, { label: '\u7ED3\u7B97\u5BA2\u6237\u540D\u79F0', name: 'vasSelfPayerName', required: true, requiredMessage: '请选择结算客户' },
                    React.createElement(CnAsyncSelect, { showSearch: true, hasClear: true, dataSource: payerFilterList, style: { width: '100%' } }))))));
}
